// extracted by mini-css-extract-plugin
module.exports = {"buttons-group":"ButtonsGroup_buttons-group__9fBtu","buttonsGroup":"ButtonsGroup_buttons-group__9fBtu","button":"ButtonsGroup_button__1TL64","upload":"ButtonsGroup_upload__2hzup"};